import React, { useState, useRef, useEffect, useContext } from "react";
import NextRouter from "next/router";
import api from "components/settings/api";

import PropTypes from "prop-types";
import ModalErrorHandler from "./ModalErrorHandler";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { makeStyles } from "@mui/styles";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { GlobalContext } from "components/context/GlobalContext"
import SkillTagInput from "./SkillTagInput";
import { TextField } from "@mui/material";
import { useAuth } from "components/context/auth";
import CustomToastMessage from "components/common/CustomToastMessage";
import { toast, Bounce } from "react-toastify";

const useStyles = makeStyles((theme) => ({
    root: {
        "& > *": {
          margin: theme.spacing(1, "auto"),
        },
        paddingRight: "1em",
        paddingLeft: "1em",
        paddingTop: "1em"
      },
    modalWrapper: {
      position: "fixed",
      placeContent: "center",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      width: "100%",
      height: "100%",
      overflow: "auto",
      zIndex: "10002",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      backgroundColor: "#00000098",
      paddingRight: 17,
      "@media screen and (maxWidth: 700)": {
        placeContent: "flex-start",
      },
    },
    containerInner: {
      padding: "20px",
      width: "100%",
      "@media screen and (max-width: 500px)": {
        padding: "0 16px",
      },
      gap: "10px",
    },
    paper: {
      borderRadius: "5px",
      boxShadow: "2.5px 5px #464646",
      maxWidth: "100%",
    },
  
    avatarDiv: {
      display: "flex",
      placeContent: "center",
    },
    avatar: {
      backgroundColor: "#2eb790",
      height: "100px",
      width: "100px",
      color: "#ffffff",
      fontSize: "48px",
      cursor: "pointer",
    },
    avatarIcon: {
      fontSize: 42,
      marginRight: 4,
    },
    title: {
      fontFamily: "Poppins",
      fontWeight: 700,
      fontSize: "24px",
      marginTop: "1rem",
    },
    subtitle: {
      fontFamily: "Open Sans",
      fontWeight: "normal",
      fontSize: 14,
      margin: "0 1rem",
      lineHeight: "150%",
      color: "rgba(0, 27, 17, 0.5)",
    },
    sub_title: {
      margin: "0 1rem",
    },
    centeredTitle: {
      width: '100%',
      textAlign: 'center',
      marginBottom: theme.spacing(1),
    },
    selector: {
      width: '100%',
    },
    team_privacy: {},
    checkbox: {
      fontFamily: "Open Sans",
      fontWeight: "normal",
      fontSize: 14,
      lineHeight: "150%",
      color: "#07b97e",
    },
    buttons: {
      color: "white",
      fontFamily: "open sans",
      minWidth: "10rem",
      backgroundColor: theme.palette.primary.main,
      margin: "1rem .5rem",
    },
    radioGroup: {
      margin: theme.spacing(1, 0),
    },
    radioButton: {
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    radioLabel: {
      display: 'flex',
      alignItems: 'center',
    },
    label: {
      fontFamily: "Open Sans",
      margin: theme.spacing(0, 1),
      fontWeight: "normal",
      fontSize: 14,
    },
    popover: {
      pointerEvents: "none",
    },
    newpaper: {
      backgroundColor: "#2eb790",
      margin: theme.spacing(4),
      padding: theme.spacing(3),
      color: "ghostwhite",
    },
  }));

const NewPublicPerson = ({ toggleModal }) => {

    const classes = useStyles();

    const { addPublicMember, showErrors, errorsArr} = useAuth();

    const initialFormState = {
        fullname: "",
        email: "",
        skill: "",
        profession: "", 
        university: "", 
        major: "",
        location: ""
      };
    
    const [skillInput, setSkillInput] = useState([]);

    
    const [
    { fullname, email, profession, university, major, location },
    setState,
    ] = useState(initialFormState);

    // Toast message function
    const notify = (message) =>
    toast.info(<CustomToastMessage message={message} />, {
      autoClose: 2000,
      closeButton: true,
      hideProgressBar: false,
      transition: Bounce,
      position: "bottom-center",
    });

    const handleSubmit = async (event) => {
        event.preventDefault();

        const skillsText = skillInput;
        let payload = {
            fullname,
            email,
            profession,
            university,
            major,
            location,
            skills: skillsText
          };
        let err = await addPublicMember(payload);
        if (err) {
          notify("Unsuccessful creation of public person.")
        } else {
          toggleModal();
          notify("Added Public Person Successfully.")
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
    
        setState((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      };
    

    return (
        <div className={"container--modal_wrapper signUpForm_delta"}>
            <div className={"container--modal-dark newPublicPerson"}>
            <Grid
              container
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
            >
              <Grid item xxs={12}>
                <Grid container justifyContent="center" alignItems="center">
                  <Grid item>
                    <div className={classes.title} aria-label="Create a new team">Add a New Public Account</div>
                  </Grid>
                </Grid>
              </Grid>
              <Button
                disableRipple={false}
                variant="text"
                className="button--modal_cancelJob"
                aria-label="Close modal"
                onClick={toggleModal}
                sx={{ position: "absolute" }}
              >
                <CloseRoundedIcon fontSize="inherit" color="inherit" />
              </Button>
            </Grid>
              <Grid item xs={12}>
                <Grid container direction="column">
                  <form
                    className={classes.root}
                    onSubmit={handleSubmit}
                    method="POST"
                    style={{ rowGap: 0, gridRowGap: 0 }}
                    aria-label="Create Team"
                  >
                    {showErrors && <ModalErrorHandler errorsArr={errorsArr}/> }
                    <TextField
                        size="small"
                        fullWidth
                        color="primary"
                        label="Fullname"
                        variant="outlined"
                        type="text"
                        name="fullname"
                        value={fullname}
                        onChange={handleInputChange}
                        minLength="1"
                        maxLength="25"
                        required
                        aria-label="Fullname"
                    />

                    <TextField
                        size="small"
                        fullWidth
                        color="primary"
                        label="Profession"
                        variant="outlined"
                        type="text"
                        name="profession"
                        value={profession}
                        onChange={handleInputChange}
                        minLength="1"
                        maxLength="25"
                        aria-label="Profession"
                    />

                    <TextField
                          size="small"
                          fullWidth
                          color="primary"
                          label="University"
                          variant="outlined"
                          type="text"
                          name="university"
                          value={university}
                          onChange={handleInputChange}
                          minLength="1"
                          maxLength="25"
                          aria-label="University"
                        />

                    <TextField
                        size="small"
                        fullWidth
                        color="primary"
                        label="Major"
                        variant="outlined"
                        type="text"
                        name="major"
                        value={major}
                        onChange={handleInputChange}
                        minLength="1"
                        maxLength="25"
                        aria-label="Major"
                    />

                    <TextField
                        size="small"
                        fullWidth
                        color="primary"
                        label="Location"
                        variant="outlined"
                        type="text"
                        name="location"
                        value={location}
                        onChange={handleInputChange}
                        minLength="1"
                        maxLength="25"
                        aria-label="Location"
                    />
                    <div>
                        <SkillTagInput setSkillInput={setSkillInput} />
                    </div>
                    <TextField
                        size="small"
                        fullWidth
                        width="100%"
                        label="Email"
                        variant="outlined"
                        type="email"
                        name="email"
                        value={email}
                        onChange={handleInputChange}
                        aria-label="Email"
                    />

                    <div className={classes.sub_title}>
                      <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Grid
                          item
                          xs={12}
                          container
                          direction="row"
                          justifyContent="center"
                          alignItems="center"
                        >
                          <div
                            style={{ margin: "0 1rem" }}
                            className="team-summary-editor-item"
                          >
                            <div
                              style={{ marginTop: "1rem", marginRight: "1rem" }}
                              className="team-summary-editor-item-content"
                            >

                            </div>
                          </div>
                          <div
                            style={{ margin: "0 1rem" }}
                            className="team-summary-editor-item"
                          >
                            <div
                              style={{ marginTop: "1rem", marginRight: "1rem" }}
                              className="team-summary-editor-item-content"
                            >
                            </div>
                          </div>
    
                        </Grid>
    
                        <Grid
                          item
                          xs={12}
                          container
                          direction="row"
                          justifyContent="center"
                          alignItems="center"
                        >
                        </Grid>
    
                      
    
                        <Grid item>
                          <Button
                            type="submit"
                            value="Create Public Person"
                            variant="contained"
                            color="primary"
                            className={classes.buttons}
                            aria-label="Create Public Person"
                          >
                            {email ? "Invite" : "Submit"}
                          </Button>
                        </Grid>
                      </Grid>
                    </div>
                  </form>
                </Grid>
              
            </Grid>
            </div>
        </div>
      );
}

export default NewPublicPerson;

NewPublicPerson.propTypes = {
  toggleModal: PropTypes.func,
};
